import { Checkbox, Input, Select } from "antd";
import { useState } from "react";
import SelectDropdownLgIcon from "../../assets/icons/SelectDropdownLgIcon";

const { Option } = Select;

interface SelectWithCheckboxProps {
  placeholder?: string | number;
  data?: { name: string; id: number | string; employeeId?: string }[];
  value?: (number | string)[];
  onChange?: (value?: (number | string)[]) => void;
  showId?: boolean;
}

const SelectWithCheckbox = ({
  placeholder,
  data,
  value = [],
  onChange,
  showId,
}: SelectWithCheckboxProps) => {
  const [searchText, setSearchText] = useState("");
  const [isAllSelected, setIsAllSelected] = useState(false);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  const filteredData = data?.filter(
    (emp) =>
      emp?.name?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
      emp?.employeeId
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase())
  );

  const handleSelectAll = (e: any) => {
    const allDataIds = filteredData?.map((emp) => emp.id);
    const newValue = e.target.checked ? allDataIds : [];
    onChange?.(newValue);
    setIsAllSelected(e.target.checked);
  };

  const handleCheckboxChange = (id: number | string) => {
    const newValue = value.includes(id)
      ? value.filter((empId) => empId !== id)
      : [...value, id];
    onChange?.(newValue);
  };

  return (
    <Select
      placeholder={placeholder}
      value={value}
      showSearch={false}
      mode="tags"
      allowClear
      onClear={() => {
        onChange && onChange([]);
        setIsAllSelected(false);
      }}
      dropdownRender={() => (
        <div className="p-2">
          <Checkbox
            onChange={handleSelectAll}
            checked={isAllSelected || value.length === filteredData?.length}
            className="text-body text-sm font-medium mb-2.5"
          >
            {isAllSelected ? "Deselect " : "Select "}
            all
          </Checkbox>
          <Input
            placeholder="Search"
            value={searchText}
            onChange={handleSearch}
          />
          <div className="max-h-40 overflow-y-auto mt-1">
            {filteredData?.map((el) => (
              <div key={el.id + el.name}>
                <Checkbox
                  className="text-body text-sm font-medium mt-1.5"
                  checked={value.includes(el.id)}
                  onChange={() => handleCheckboxChange(el.id)}
                >
                  {`${el.name}${showId ? `, ID-${el?.employeeId}` : ""}`}
                </Checkbox>
              </div>
            ))}
          </div>
        </div>
      )}
      tagRender={({ label }) => (
        <div className=" bg-[#f0f0f0] rounded-md text-body mr-1 px-2 py-[5px]">
          {label}
        </div>
      )}
      maxTagCount={2}
      maxTagPlaceholder={(val) => `+ ${val?.length}`}
      suffixIcon={<SelectDropdownLgIcon />}
    >
      {value.map((empId) => {
        const el = data?.find((emp) => emp.id === empId);
        return (
          <Option key={empId} value={empId}>
            {el?.name}
          </Option>
        );
      })}
    </Select>
  );
};

export default SelectWithCheckbox;
